import { Box, Typography } from "@material-ui/core";
import React from "react";
import Text from "../../../shared/components/Text";
import CupsInvoiceExample from "../../../../assets/cups_factura_endesa.jpg";
import { DocumentType } from "@nemuru-eng/js-api-client";

export const genderTypesConfig = {
  MALE: {
    name: "MALE",
    value: "M",
  },
  FEMALE: {
    name: "FEMALE",
    value: "F",
  },
};

export const docIdTypes = {
  DNI_ES: "DNI_ES",
  NIE_UE: "NIE_UE",
  NIE_NON_UE: "NIE_NON_UE",
  PASSPORT: "PASSPORT",
};

export const docIdSide = {
  DNI_ES_FRONT: "dniEsFront",
  DNI_ES_BACK: "dniEsBack",
  NIE_UE_FRONT: "nieUeFront",
  NIE_UE_BACK: "nieUeBack",
  NIE_NON_UE_FRONT: "nieNonUeFront",
  NIE_NON_UE_BACK: "nieNonUeBack",
  PASSPORT_FRONT: "passportFront",
};

export const documentTypes = [
  {
    value: 62,
    patchValueId: DocumentType.NIF, //todo => replace all the values of docIdTypes for js-api-client DocumentType values and avoid mapper
    id: docIdTypes.DNI_ES,
    display: <Text tId={docIdTypes.DNI_ES} />,
  },
  {
    value: 229,
    patchValueId: DocumentType.NIE_EU,
    id: docIdTypes.NIE_UE,
    display: <Text tId={docIdTypes.NIE_UE} />,
  },
  {
    value: 188,
    patchValueId: DocumentType.NIE_NON_EU,
    id: docIdTypes.NIE_NON_UE,
    display: <Text tId={docIdTypes.NIE_NON_UE} />,
  },
  {
    value: 0,
    patchValueId: DocumentType.PASSPORT,
    id: docIdTypes.PASSPORT,
    display: <Text tId={docIdTypes.PASSPORT} />,
  },
];

export const ownershipTypesConfig = {
  OWNERSHIP: {
    name: "OWNERSHIP",
    value: "ownership",
  },
  RENT: {
    name: "RENT",
    value: "rent",
  },
  LEASING: {
    name: "LEASING",
    value: "leasing",
  },
  PARTNER: {
    name: "PARTNER",
    value: "partner",
  },
  PARENTS: {
    name: "PARENTS",
    value: "parents",
  },
  USUFRUCT: {
    name: "USUFRUCT",
    value: "usufruct",
  },
  OTHER: {
    name: "OTHER",
    value: "other",
  },
};

export const ownershipTypesWithoutOtherConfig = {
  OWNERSHIP: {
    name: "OWNERSHIP",
    value: "ownership",
  },
  RENT: {
    name: "RENT",
    value: "rent",
  },
  LEASING: {
    name: "LEASING",
    value: "leasing",
  },
  PARTNER: {
    name: "PARTNER",
    value: "partner",
  },
  PARENTS: {
    name: "PARENTS",
    value: "parents",
  },
  USUFRUCT: {
    name: "USUFRUCT",
    value: "usufruct",
  },
};

export const residencePropertyTypesConfig = {
  PUBLIC_DEED: {
    name: "PUBLIC_DEED",
    value: "public_deed",
  },
  PRIVATE_CONTRACT: {
    name: "PRIVATE_CONTRACT",
    value: "private_contract",
  },
  SOCIAL_HOUSING: {
    name: "SOCIAL_HOUSING",
    value: "social_housing",
  },
  OTHERS: {
    name: "OTHERS",
    value: "other",
  },
};

export const residencePropertyTypesWithoutOthersConfig = {
  PUBLIC_DEED: {
    name: "PUBLIC_DEED",
    value: "public_deed",
  },
  PRIVATE_CONTRACT: {
    name: "PRIVATE_CONTRACT",
    value: "private_contract",
  },
  SOCIAL_HOUSING: {
    name: "SOCIAL_HOUSING",
    value: "social_housing",
  },
};

export const maritalStatusTypesConfig = {
  MARRIED: {
    name: "MARRIED",
    value: "married",
  },
  DIVORCED: {
    name: "DIVORCED",
    value: "divorced",
  },
  SEPARATED: {
    name: "SEPARATED",
    value: "separated",
  },
  SINGLE: {
    name: "SINGLE",
    value: "single",
  },
  WIDOWED: {
    name: "WIDOWED",
    value: "widowed",
  },
  SEPARATED_IN_FACT: {
    name: "SEPARATED_IN_FACT",
    value: "separated_in_fact",
  },
  SIMILAR_SITUATION_TO_MARRIED: {
    name: "SIMILAR_SITUATION_TO_MARRIED",
    value: "similar_situation_to_married",
  },
};

export const maritalRegimeTypesConfig = {
  MATRIMONIAL_ASSETS: {
    name: "MATRIMONIAL_ASSETS",
    value: "matrimonial_assets",
  },
  SEPARATE_PROPERTY: {
    name: "SEPARATE_PROPERTY",
    value: "separate_property",
  },
  OTHERS: {
    name: "OTHERS",
    value: "others",
  },
};

export const maritalStatusThatAllowsMaritalRegime = "married";

export const infoDataPropertyTypeForm = [
  {
    title: <Text tId="WHAT_IS_PUBLIC_DEED" />,
    description: (
      <>
        <Typography variant="body2">
          <Text tId="PUBLIC_DEED_EXPLANATION" />
        </Typography>
      </>
    ),
  },
  {
    title: <Text tId="WHAT_IS_PRIVATE_CONTRACT" />,
    description: (
      <>
        <Typography variant="body2">
          <Text tId="PRIVATE_CONTRACT_EXPLANATION" />
        </Typography>
      </>
    ),
  },
  {
    title: <Text tId="WHAT_IS_SOCIAL_HOUSING" />,
    description: (
      <>
        <Typography variant="body2">
          <Text tId="SOCIAL_HOUSING_EXPLANATION" />
        </Typography>
      </>
    ),
  },
];

export const infoDataFamilyForm = [
  {
    title: <Text tId="WHAT_IS_MATRIMONIAL_ASSETS" />,
    description: (
      <>
        <Typography variant="body2">
          <Text tId="MATRIMONIAL_ASSETS_EXPLANATION" />
        </Typography>
      </>
    ),
  },
  {
    title: <Text tId="WHAT_IS_SEPARATE_PROPERTY" />,
    description: (
      <>
        <Typography variant="body2">
          <Text tId="SEPARATE_PROPERTY_EXPLANATION" />
        </Typography>
      </>
    ),
  },
];

export const infoDataDocumentType = [
  {
    title: <Text tId="DNI_ES_TITLE" />,
    description: (
      <Typography variant="body2">
        <Text tId="DNI_ES_EXPLANATION" />
      </Typography>
    ),
  },
  {
    title: <Text tId="NIE_UE_TITLE" />,
    description: (
      <Typography variant="body2">
        <Text tId="NIE_UE_EXPLANATION" />
      </Typography>
    ),
  },
  {
    title: <Text tId="NIE_NON_UE_TITLE" />,
    description: (
      <Typography variant="body2">
        <Text tId="NIE_NON_UE_EXPLANATION" />
      </Typography>
    ),
  },
];

export const infoDataSEPAExplanation = [
  {
    title: <Text tId="SEPA_BANK_ACCOUNT_TITLE" />,
    description: (
      <Typography variant="body2">
        <Text tId="SEPA_BANK_ACCOUNT_EXPLANATION" />
      </Typography>
    ),
  },
];

export const infoDataCupsNumber = [
  {
    title: <Text tId="WHAT_IS_CUPS" />,
    description: (
      <Typography variant="body2">
        <Text tId="CUPS_CODE_EXPLANATION" />
      </Typography>
    ),
  },
  {
    title: <Text tId="HOW_TO_FIND_CUPS" />,
    description: (
      <Box style={{ display: "block" }}>
        <Typography variant="body2">
          <Text tId="HOW_TO_FIND_CUPS_EXPLANATION_1" />
        </Typography>
        <p>
          <img
            alt="Cups Invoice Example"
            style={{
              maxWidth: "90%",
              padding: "1rem",
            }}
            src={CupsInvoiceExample}
          />
        </p>
        <Typography variant="body2">
          <Text tId="HOW_TO_FIND_CUPS_EXPLANATION_2" />
        </Typography>
      </Box>
    ),
  },
];
